import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";
import "./styles/age-adaptive-theme.css";
import { registerServiceWorker } from "./utils/registerServiceWorker";

// Register service worker for PWA functionality
registerServiceWorker();

createRoot(document.getElementById("root")!).render(<App />);
